<template>
    <section class="promo-section">
        <div class="container">
            <div class="heading-box">
                <h1><strong>{{$t('promotions.godfather.our_gift_to_you')}}
                </strong></h1>
                <p>{{$t('promotions.godfather.we_pay', {amount: '€200'})}}</p>
            </div>

            <div class="promo-grid">
                <div class="grid-item grid-item-payment-method">
                    <!-- <h2>Payment method:</h2> -->
                    <div class="box box-drop">
                        <PaymentTypes @select="changePaymentType" :opened="true" :types="promotion.payment_types" />
                    </div>
                </div>
                <div class="grid-item grid-item-premium">
                    <div v-if="promotion.packages.length" class="box">
                        <svg width="76" height="66" viewBox="0 0 76 66" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_1_285)">
                                <path d="M13.0376 51.366H27.8813C27.8714 50.0552 28.1287 48.7559 28.6377 47.546C29.1468 46.3361 29.8972 45.2405 30.8439 44.3248C32.2551 42.933 34.0501 41.9855 36.0032 41.6015C37.9563 41.2175 39.9803 41.4141 41.821 42.1665C43.6617 42.919 45.2368 44.1937 46.3484 45.8305C47.4601 47.4673 48.0586 49.3932 48.0688 51.366H62.7147L70.4396 30.1198C70.8598 30.2495 71.2983 30.3116 71.7384 30.3036C72.5827 30.3036 73.4081 30.0555 74.11 29.5906C74.8119 29.1257 75.3589 28.4649 75.6817 27.6919C76.0046 26.9189 76.0887 26.0684 75.9235 25.248C75.7584 24.4276 75.3513 23.6742 74.7539 23.0831C74.1564 22.492 73.3954 22.0898 72.5672 21.9273C71.739 21.7648 70.8807 21.8494 70.101 22.1704C69.3213 22.4914 68.6552 23.0343 68.1871 23.7305C67.7189 24.4267 67.4696 25.2448 67.4708 26.0813C67.4698 26.9622 67.7514 27.8206 68.2749 28.5326L63.8898 32.1482C57.7049 37.1671 53.8765 34.8384 55.0516 27.068L55.7319 22.6557C55.9758 22.7065 56.2251 22.7271 56.4741 22.717C57.4788 22.7153 58.4505 22.3614 59.2172 21.718C59.9838 21.0746 60.496 20.1832 60.6629 19.2016C60.8299 18.2199 60.641 17.2114 60.1295 16.3546C59.6181 15.4977 58.8171 14.8478 57.8685 14.5199C56.9198 14.1921 55.8847 14.2073 54.9463 14.5631C54.008 14.9188 53.2269 15.5921 52.7414 16.4636C52.256 17.3352 52.0974 18.3488 52.2938 19.3251C52.4902 20.3014 53.029 21.1773 53.8146 21.7978L52.7694 23.4524C47.574 31.1677 43.7456 28.2262 42.255 20.5783L39.5461 8.14429C40.3149 7.82853 40.9717 7.29355 41.4331 6.60726C41.8945 5.92097 42.1397 5.11431 42.1375 4.28969C42.1117 3.14624 41.6364 2.05796 40.8126 1.25669C39.9889 0.455425 38.882 0.00450678 37.7277 0C36.598 0.00162103 35.5151 0.446988 34.7162 1.23847C33.9174 2.02995 33.4679 3.10296 33.4663 4.22228C33.4584 5.14831 33.7643 6.05019 34.3351 6.7835C34.9059 7.51681 35.7085 8.03914 36.6144 8.26685L34.8208 15.3694C33.3983 21.8591 31.5428 34.8323 23.2303 23.7526L21.8758 21.9142C22.4238 21.5205 22.8709 21.0049 23.1813 20.4089C23.4917 19.8129 23.6568 19.1531 23.6632 18.4825C23.6632 17.6474 23.4133 16.831 22.9451 16.1367C22.4768 15.4423 21.8113 14.9011 21.0326 14.5816C20.2539 14.262 19.3971 14.1784 18.5705 14.3413C17.7439 14.5042 16.9846 14.9063 16.3886 15.4968C15.7926 16.0873 15.3868 16.8397 15.2223 17.6587C15.0579 18.4778 15.1423 19.3267 15.4648 20.0982C15.7874 20.8698 16.3336 21.5292 17.0343 21.9932C17.7351 22.4571 18.559 22.7047 19.4019 22.7047C19.7144 22.6941 20.0251 22.653 20.3296 22.5822L20.6388 25.4624C21.1955 29.3783 21.8758 34.6546 17.3608 34.4033C15.1405 34.2808 14.2684 33.5454 12.5428 32.3198L7.66292 28.888C8.22543 28.1598 8.52978 27.268 8.5288 26.351C8.53003 25.5144 8.28078 24.6963 7.8126 24.0001C7.34441 23.304 6.67834 22.761 5.89865 22.4401C5.11896 22.1191 4.2607 22.0345 3.43246 22.1969C2.60423 22.3594 1.84324 22.7616 1.24579 23.3527C0.648338 23.9439 0.241276 24.6973 0.0761082 25.5177C-0.0890591 26.3381 -0.00490882 27.1886 0.317911 27.9616C0.640732 28.7346 1.18771 29.3953 1.88965 29.8602C2.59158 30.3251 3.41692 30.5733 4.26123 30.5733C4.79122 30.5658 5.31532 30.4619 5.80745 30.2669L13.0376 51.366ZM37.7277 1.89972C38.1928 1.89972 38.6474 2.03645 39.0341 2.29261C39.4207 2.54876 39.7219 2.91281 39.8996 3.33868C40.0773 3.76455 40.1235 4.23309 40.0323 4.68498C39.9411 5.13686 39.7167 5.55179 39.3874 5.87721C39.0581 6.20264 38.6387 6.42394 38.1824 6.5131C37.7261 6.60226 37.2533 6.55527 36.824 6.37808C36.3946 6.20089 36.028 5.90146 35.7705 5.5177C35.513 5.13394 35.3762 4.68312 35.3774 4.22228C35.3791 3.60574 35.6274 3.015 36.068 2.57961C36.5086 2.14422 37.1054 1.89972 37.7277 1.89972ZM71.59 23.6301C72.0976 23.6362 72.592 23.7913 73.0106 24.0758C73.4292 24.3602 73.7533 24.7613 73.9419 25.2283C74.1305 25.6953 74.1751 26.2072 74.0701 26.6993C73.965 27.1914 73.7151 27.6416 73.3518 27.9929C72.9886 28.3443 72.5283 28.581 72.0293 28.6732C71.5303 28.7654 71.0149 28.7089 70.5482 28.5108C70.0816 28.3128 69.6847 27.9821 69.4078 27.5605C69.1308 27.139 68.9863 26.6456 68.9923 26.1426C68.9956 25.8084 69.0654 25.4781 69.1979 25.1707C69.3303 24.8633 69.5227 24.5849 69.7641 24.3514C70.0055 24.1179 70.2911 23.934 70.6044 23.8102C70.9178 23.6864 71.2527 23.6252 71.59 23.6301ZM4.17464 23.6301C4.52189 23.6132 4.86899 23.6664 5.19488 23.7864C5.52077 23.9064 5.81865 24.0908 6.07046 24.3283C6.32226 24.5658 6.52273 24.8516 6.65971 25.1682C6.79669 25.4848 6.86733 25.8257 6.86733 26.1702C6.86733 26.5147 6.79669 26.8556 6.65971 27.1722C6.52273 27.4888 6.32226 27.7746 6.07046 28.0121C5.81865 28.2496 5.52077 28.434 5.19488 28.554C4.86899 28.674 4.52189 28.7272 4.17464 28.7103C3.49932 28.6974 2.85664 28.42 2.38721 27.9388C1.91778 27.4576 1.65982 26.8118 1.66976 26.1426C1.66562 25.812 1.72818 25.484 1.85376 25.1777C1.97935 24.8714 2.16542 24.5931 2.40107 24.359C2.63671 24.125 2.91717 23.9399 3.22598 23.8148C3.5348 23.6896 3.86574 23.6268 4.19938 23.6301H4.17464ZM19.34 15.9331C20.0115 15.9364 20.6546 16.2021 21.1295 16.6726C21.6043 17.1431 21.8726 17.7803 21.8758 18.4457C21.8758 19.1202 21.6054 19.767 21.124 20.244C20.6427 20.7209 19.9898 20.9889 19.3091 20.9889C18.6283 20.9889 17.9755 20.7209 17.4941 20.244C17.0128 19.767 16.7423 19.1202 16.7423 18.4457C16.7691 17.7773 17.0533 17.1444 17.5364 16.6771C18.0195 16.2098 18.6649 15.9436 19.34 15.9331ZM56.3504 15.9331C56.6875 15.9331 57.0212 15.9989 57.3327 16.1267C57.6441 16.2545 57.927 16.4419 58.1654 16.678C58.4037 16.9142 58.5928 17.1945 58.7218 17.5031C58.8508 17.8116 58.9171 18.1423 58.9171 18.4763C58.9171 18.8103 58.8508 19.141 58.7218 19.4496C58.5928 19.7581 58.4037 20.0385 58.1654 20.2746C57.927 20.5108 57.6441 20.6981 57.3327 20.8259C57.0212 20.9537 56.6875 21.0195 56.3504 21.0195C55.6697 21.0195 55.0168 20.7516 54.5355 20.2746C54.0541 19.7977 53.7837 19.1508 53.7837 18.4763C53.7837 17.8018 54.0541 17.155 54.5355 16.678C55.0168 16.2011 55.6697 15.9331 56.3504 15.9331ZM13.0561 57.2613H29.842C30.1379 57.6765 30.4689 58.066 30.8315 58.4256C32.7167 60.2948 35.2711 61.3499 37.938 61.361C40.6206 61.3379 43.1899 60.2858 45.1063 58.4256C45.4689 58.066 45.7999 57.6765 46.0959 57.2613H62.7951V66H13.0376V57.2429L13.0561 57.2613Z" fill="#B98A56"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M37.9381 44.4473C39.3191 44.4473 40.6692 44.8531 41.8175 45.6133C42.9658 46.3736 43.8608 47.4541 44.3893 48.7183C44.9178 49.9826 45.0561 51.3737 44.7866 52.7158C44.5172 54.0578 43.8522 55.2906 42.8756 56.2582C41.8991 57.2258 40.6549 57.8848 39.3003 58.1517C37.9458 58.4187 36.5418 58.2817 35.2659 57.758C33.99 57.2343 32.8994 56.3476 32.1321 55.2098C31.3649 54.072 30.9553 52.7344 30.9553 51.366C30.9545 50.4572 31.1346 49.5572 31.4852 48.7174C31.8358 47.8776 32.3501 47.1146 32.9987 46.472C33.6473 45.8293 34.4174 45.3197 35.2649 44.9723C36.1125 44.6249 37.0209 44.4465 37.9381 44.4473Z" fill="#B98A56"/>
                            </g>
                            <defs>
                                <clipPath id="clip0_1_285">
                                    <rect width="76" height="66" fill="white"/>
                                </clipPath>
                            </defs>
                        </svg>
                        <h2>{{$t('promotions.godfather.premium')}}</h2>
                        <h3>{{$t('promotions.godfather.30')}}</h3>
                        <div class="divider"></div>

                        <h4>{{promotion.packages[0].credits}} {{$t('credits.credits')}}
                            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0.291359 14.4794C-0.104716 14.8335 -0.0957487 15.4013 0.312284 15.7463C0.718822 16.0914 1.37048 16.0836 1.76655 15.7281L9.70601 8.59377L8.96916 7.97005L9.70899 8.59507C10.1051 8.23829 10.0961 7.66926 9.68657 7.3242C9.67462 7.31378 9.66266 7.30467 9.6507 7.29555L1.76506 0.271909C1.36898 -0.0835706 0.718822 -0.0913833 0.310789 0.253679C-0.0957487 0.598741 -0.104716 1.16516 0.291359 1.52064L7.53431 7.97266L0.291359 14.4794Z" fill="#B98A56"/>
                            </svg>
                            <span>{{promotion.packages[0].currency}} {{promotion.packages[0].price}}</span>
                        </h4>
                        <button @click="packageClickHandler(promotion.packages[0])" class="button button--primary">{{$t('promotions.godfather.buy')}}</button>
                        <!-- <p class="text">Secure Your Dinnerdate</p> -->
                         <div class="o-flex">
                             <div class="check-box o-flex">
                                 <input id="check1" type="checkbox" checked name="" disabled>
                                 <label for="check1">
                                     <div class="check-icon">
                                         <svg fill="none" width="9" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="4" viewBox="0 0 24 24">
                                             <path d="M20 6 9 17l-5-5"/>
                                         </svg>
                                     </div>
                                 </label>
                                 <p class="check-text" v-html="$t(theme === 'luxliebe' ? 'terms.luxliebe.payment' : 'payment.terms', {terms_link: '/terms', privacy_link: '/privacy'})"></p>
                             </div>
                         </div>

                    </div>
                    <a href="javascript:;"  @click="popupTrigger = true" class="popup-trigger">{{$t('promotions.godfather.rules', {amount: '€200'})}}</a>
                </div>
                <div class="grid-item grid-item-gift">
                    <h3 class="mb0">{{$t('promotions.godfather.our_gift')}}</h3>
                    <h2 class="mb0">€200</h2>
                    <p><span>{{$t('promotions.godfather.on_your')}}</span></p>
                    <div class="box1">
                        <img src="@/assets/img/big-gift.png" class="big-img" alt="big-img">
                        <img src="@/assets/img/small-gift.png" class="small-img" alt="small-img">
                        <transition name="fade" mode="out-in">
                            <div class="popup" v-if="popupTrigger">
                                <a href="javascript:;" class="close" @click="popupTrigger = false">
                                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0.981683 17.0396C1.93901 14.9401 3.47608 12.5489 5.32043 10.2203C3.61003 8.3547 1.84749 6.62344 0.212394 5.17873C-0.0296413 4.96551 -0.0709572 4.57221 0.120166 4.30211C0.202804 4.18475 0.320711 4.10473 0.452105 4.07683C1.76259 3.7878 2.79826 3.92521 3.72276 4.37708C4.62484 4.81857 5.38913 5.54831 6.18973 6.46968C6.5348 6.86727 6.92159 7.33119 7.33268 7.84123C7.63977 7.50103 7.95118 7.16573 8.26683 6.83542C11.1542 3.81497 14.3854 1.23775 17.2423 0.0402533C17.5318 -0.0812662 17.8552 0.0815676 17.9641 0.404643C18.0035 0.521578 18.0107 0.648994 17.9847 0.770507C17.9587 0.892021 17.9007 1.00208 17.8182 1.08653C16.6305 2.50074 15.2644 3.98986 13.8388 5.54357C12.3666 7.14858 10.8303 8.82375 9.39897 10.5102C9.73537 10.9604 10.0684 11.4137 10.398 11.8701C11.7162 13.6965 12.9198 15.4953 13.5632 16.6889C13.7219 16.9849 13.6354 17.3691 13.3702 17.5462C13.2568 17.6221 13.1228 17.6505 12.9923 17.6262L11.2302 17.3768C11.1561 17.3664 11.0845 17.3395 11.0199 17.2977C10.9553 17.2559 10.8988 17.2001 10.8539 17.1335C9.87607 15.687 8.75201 14.2142 7.55542 12.7764C6.26655 14.443 5.15563 16.0945 4.38704 17.6741C4.28285 17.8882 4.08213 18.0066 3.87752 17.9997L1.47232 17.9472C1.16351 17.942 0.917235 17.6577 0.921882 17.3131C0.923205 17.2181 0.943642 17.1246 0.981683 17.0396Z" fill="white"/>
                                    </svg>
                                </a>

                                <h3>{{$t('promotions.godfather.please_provide')}}</h3>
                                <ul>
                                    <li><p>{{$t('promotions.godfather.both')}}.</p></li>
                                    <li><p>{{$t('promotions.godfather.send')}}</p></li>
                                    <li><p>{{$t('promotions.godfather.rights_to_publish')}}</p></li>
                                </ul>
                                <p>{{$t('promotions.godfather.compliant', {amount1: '€200', credits: 300, amount2: '€300'})}}</p>
                            </div>
                        </transition>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import {CREDIT_CARD, DIRECT_DEBIT, ONLINE_BANK_TRANSFER, BANK_TRANSFER, PAYPAL} from "@/types/payment";
    import PaymentTypes from "@/components/payment/PaymentTypes.vue";
    import ThemeMixin from "@/mixins/ThemeMixin";
    export default {
        name: "Godfather",
        mixins: [ThemeMixin],
        components: {
            PaymentTypes,
        },
        emits: ['select', 'selected'],
        props: {
            packages: {
                type: Array
            },
            working: {
                type: Boolean,
                required: true
            },
            promotion: {
                type: Object,
                required: true
            },
            paymentModal: {
                type: Boolean,
                default: false
            },
            confirmed: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            changePaymentType(value) {
                this.$emit('select', value)
            },
            packageClickHandler(p) {

                this.$emit('selected', p)

            },
        },
        data() {
            return {
                type: null,
                popupTrigger: false,
            }
        },
        created() {
            this.CREDIT_CARD = CREDIT_CARD
            this.DIRECT_DEBIT = DIRECT_DEBIT
            this.ONLINE_BANK_TRANSFER = ONLINE_BANK_TRANSFER
            this.BANK_TRANSFER = BANK_TRANSFER
            this.PAYPAL = PAYPAL
        }
    }
</script>
<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:ital,wght@0,200..800;1,200..800&family=Red+Hat+Display:ital,wght@0,300..900;1,300..900&display=swap');
.check-box input, .radio-box input {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    z-index: -1;
}
.radio-box label {
    display: flex;
    align-items: center;
}

.check-box label {
    display: flex;
}

.radio-box {
    vertical-align: middle;
    margin-bottom: 15px;
}
.radio-box .radio-icon {
    width: 14px;
    height: 14px;
    border-radius: 2px;
    border: 1px solid #FFF;
    background-color: transparent;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease;
}
.radio-box .radio-icon:before {
    position: absolute;
    left: 50%;
    top: 50%;
    content: "";
    width: 8px;
    height: 8px;
    background-color: #000;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    border-radius: 50%;
    transition: all 0.3s ease;
    visibility: hidden;
    opacity: 0;
}
.radio-box label {
    font-weight: 400;
    cursor: pointer;
}

.radio-box input:checked + label .radio-icon {
    background-color: #fff;
}
.radio-box input:checked + label .radio-icon:before {
    visibility: visible;
    opacity: 1;
}
.radio-box input:disabled + label {
    pointer-events: none;
    opacity: 0.8;
    cursor: not-allowed;
}
.radio-box .radio-text {
    margin-bottom: 0;
    color: #fff;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    font-weight: 500;
    margin-left: 10px;
}
.check-box {
    margin-bottom: 15px;
}
.check-box .check-icon {
    width: 10px;
    min-width: 10px;
    height: 10px;
    border-radius: 2%;
    background-color: #fff;
    margin-right: 10px;
    position: relative;
    transition: all 0.3s ease;
}
.check-box .check-icon svg {
    position: absolute;

    left: 50%;
    top: 50%;
    content: "";
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    transition: all 0.3s ease;
    visibility: hidden;
    opacity: 0;
}
.check-box label {
    font-weight: 400;
    cursor: pointer;
}
.check-box input:checked + label .check-icon svg {
    visibility: visible;
    opacity: 1;
}
.check-box input:disabled + label {
    pointer-events: none;
    opacity: 0.8;
    cursor: not-allowed;
}
.check-box .check-text {
    margin-bottom: 0;
    color: #fff;
    font-size: 14px;
    margin-top: -5px;
    text-align: left;
    line-height: 1.4;
    font-family: "Red Hat Display", sans-serif;
}

.check-box .check-text a {
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    text-decoration: none;
}

.container {
    width: 100%;
    max-width: 1220px;
    margin: 0 auto;
}

.promo-section {
    // min-height: calc(100dvh - 60px);
    padding: 80px 0;
    background: #111317;
    background-image: url('../../assets/img/gold-orb.svg');
    background-repeat: no-repeat;
    background-position: 50% 110%;
}

.heading-box {
    text-align: center;
    margin-bottom: 30px;
}

.heading-box h1 {
    color: #FFF;
    font-size: 48px;
    margin-bottom: 10px;
    font-family: "Red Hat Display", sans-serif;
}

.heading-box p {
    color: #B98A56;
    font-size: 18px;
    font-family: "Plus Jakarta Sans", sans-serif;
    margin-bottom: 0;
}

.promo-grid {
    display: flex;
    gap: 50px;
    align-items: center;

}

.grid-item {
    width: calc(33.33% - 25px);
}

.grid-item .box {
    padding: 25px;
    border-radius: 16px;
    /* border: 1px solid #FFF; */
    background: linear-gradient(100deg, rgba(255, 255, 255, 0.03) -0.77%, rgba(255, 255, 255, 0.04) 101.05%);
    box-shadow: 4px 20px 40px 0px rgba(0, 0, 0, 0.77);
    backdrop-filter: blur(5.129803657531738px);
}

.grid-item-payment-method .box {
    margin-bottom: 25px;
}

.grid-item-payment-method .drop-trigger {
    border-radius: 50px;
    background: linear-gradient(100deg, rgba(255, 255, 255, 0.03) -0.77%, rgba(255, 255, 255, 0.04) 101.05%);
    box-shadow: 4px 20px 40px 0px rgba(0, 0, 0, 0.77);
    backdrop-filter: blur(5.129803657531738px);
    height: 50px;
    margin-bottom: 15px;
    padding: 0 25px;

    align-items: center;
    justify-content: space-between;
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    display: none;
}

.grid-item-payment-method .drop-trigger span {
    display: flex;
    align-items: center;
    gap:10px;
    color: #fff;
}

.grid-item-payment-method .drop-trigger p {
    margin-bottom: 0;
}

.grid-item-payment-method .check-box {
    position: relative;
    z-index: 1;
}

.grid-item-payment-method .check-box .check-text {
    color: #FFF;
    font-family: "Red Hat Display", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.4;
}

.grid-item-payment-method .check-box .check-text a {
    color: #B98A56;
    text-decoration: none;
}


.grid-item-payment-method h2 {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 25px;
    color: #fff;
    font-family: "Red Hat Display", sans-serif;
}

.grid-item-payment-method p {
    color: #B98A56;
    font-size: 14px;
    font-weight: 600;
    margin-bottom: 25px;
    font-family: "Red Hat Display", sans-serif;
}

.grid-item-premium {
    text-align: center;
}

.grid-item-premium .box {
    margin-bottom: 15px;
}

.grid-item-premium .popup-trigger {
    color: rgba(255, 255, 255, 0.40);
    font-family: "Red Hat Display", sans-serif;
    font-size: 18px;
    position: relative;
    z-index: 1;
    transition: all .3s ease;
    text-decoration: none;
}

.grid-item-premium .popup-trigger:hover {
    color: #fff;
}

.grid-item-premium h2 {
    font-family: "Red Hat Display", sans-serif;
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 10px;
    margin-top: 17px;
    color: #fff;
}

.grid-item-premium h3 {
    color: #B98A56;
    font-family: "Plus Jakarta Sans";
    font-size: 24px;
    font-weight: 500;
}

.grid-item-premium .divider {
    background-color: #fff;
    height: 1px;
    width: 80%;
    margin: 20px auto 15px;
}

.grid-item-premium h4 {
    font-family: "Plus Jakarta Sans";
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    margin-bottom: 35px;
    color: #fff;
}

.grid-item-premium h4 span {
    color: rgba(255, 255, 255, 0.50);
    font-weight: 500;
}

.grid-item-premium .text {
    color: rgba(255, 255, 255, 0.80);
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    margin-top: 10px;
    margin-bottom: 20px;
}

.button--primary {
    width: 274px;
    height: 64px;
    border-radius: 54px;
    background: #B98A56;
    box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.73), -5px -3px 20.544px 0px #2F393D;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    font-family: "Red Hat Display";
    font-size: 20px;
    font-weight: 600;
}

.grid-item-premium .button--primary {
    margin-bottom: 20px;
}

.grid-item-premium .check-box {
    margin-bottom: 0;
}

.grid-item-premium .link {
    color: rgba(255, 255, 255, 0.80);
    font-family: "Red Hat Display", sans-serif;
    font-size: 16px;
    text-decoration: none;
    margin-top: 10px;
    display: inline-block;
    margin-bottom: 15px;
}

.grid-item-gift h3 {
    color: #B98A56;
    font-family: "Red Hat Display", sans-serif;
    font-size: 20px;
    font-weight: 600;
}

.grid-item-gift h2 {
    color: #FFF;
    font-family: "Red Hat Display", sans-serif;
    font-size: 50px;
    font-weight: 900;
}

.grid-item-gift p {
    color: #ffffff;
    font-family: "Red Hat Display", sans-serif;
    font-size: 18px;
    font-weight: 400;
    margin-bottom: 10px;
    width: calc(100% - 130px);
    line-height: 1.2;
}

.grid-item-gift p span {
    color: #B98A56;
}


.box1 {
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-image: url('../../assets/img/couple.png');
    background-size: cover;
    aspect-ratio: 1 / 1;
    border-radius: 16px;
    box-shadow: 1px 10px 14.8px 0px rgba(0, 0, 0, 0.63);
    position: relative;
}

.box1 .big-img {
    position: absolute;
    right: 0;
    bottom: 100%;
    transform: translate(40px, 35px);
    max-width: 190px;
}

.box1 .small-img {
    position: absolute;
    left: -30px;
    bottom: -40px;
}

.popup {
    position: absolute;
    padding: 23px 15px;
    border-radius: 16px;
    left: 0;
    bottom: 0;
    width: 100%;
    background-image: url('../../assets/img/info-box.png');
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: 100% 100%;
    box-shadow: -30px 20px 40px 0px rgba(0, 0, 0, 0.87);
}

.popup h3 {
    color: #FFF;
    font-family: "Plus Jakarta Sans";
    font-size: 20px;
    font-weight: 300;
    margin-bottom: 20px;
}

.popup .close {
    float: right;
}

.popup ul {
    padding-left: 20px;
    list-style-type:disc;
    padding-right: 35px;
    margin-bottom: 20px;
}

.popup ul {
    color: #FFF;
}

.popup ul p {
    color: #FFF;
    font-family: "Plus Jakarta Sans";
    font-size: 16px;
    line-height: 1.3;
    font-weight: 300;
}

.popup >p {
    margin-bottom: 0;
    font-family: "Plus Jakarta Sans";
    font-size: 14px;
    opacity: .8;
}

.payment-type {
    margin-top: 0;
}

@media(max-width: 1300px) {

    .header--main {
        height: 48px;
        padding: 0 24px;
    }

    .grid-item-premium {
        margin-bottom: 80px;
    }

    .grid-item-payment-method .drop-trigger {
        display: flex;
    }

    .grid-item-payment-method .box-drop {
        padding: 20px 0;
    }

    .box-drop .dropdown {
        padding: 25px;
    }

    .grid-item-payment-method .dropdown > p {
        display: none;
    }

    .promo-grid {
        flex-direction: column;
        gap: 0;
    }

    .promo-grid .grid-item {
        width: 380px;
    }

    .promo-section {
        padding: 20px 0 80px;
        overflow: hidden;
    }

    .heading-box h1 {
        font-size: 28px;
    }

    .heading-box p {
        font-size: 16px;
    }
}


@media(max-width: 480px) {

    .container {
        padding: 0 10px;
    }
    .promo-grid .grid-item {
        width: 100%;
    }
}
</style>

<style lang="scss">
    // @media(max-width: 1300px) {
        .grid-item-payment-method {

            .payment-type {

                h3 {
                    color: #fff;
                    margin-bottom: 20px;
                }

                .change-trigger {
                    display: none;
                }
            }
        }

        .grid-item-premium {

            .check-box .check-text a {
                color: #B98A56;
                font-family: "Red Hat Display", sans-serif;
                font-size: 14px;
                text-decoration: none;
            }
        }

    // }

</style>
